import { useEffect } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLHVQBridgeService } from 'ml-services-common-react'
import { MLModalService } from 'ml-portals-services-react';

import messages from './MLHVQLandingPage.messages';

function MLHVQLandingPage(props) {
    const {
        history,
        match: {
            params: { hvqTransactionId }
        },
        showCustomHeader,
        landedInHVQPage
    } = props;
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();

    const handleBridgingError = (quoteID, error) => {
        const title = translator(messages.errorLoadingOperation);
        const defaultErrorMessage = translator(messages.unableToLoad, { quoteID: quoteID } );
        console.error(error);
        showErrorModal(title, defaultErrorMessage);
    };

    useEffect(() => {
        if(!landedInHVQPage) {
            const bridgingPromise = MLHVQBridgeService.createFromHVQTransactionIdOnNewAccount(hvqTransactionId, authHeader);
            showProgressDialog(platformMessages.loading, bridgingPromise, true);

            bridgingPromise.then((hvqRes) => {
                if (!_.isUndefined(hvqRes) && hvqRes.jobID) {
                    history.push('/quoteentry', {
                        quoteID: hvqRes.jobID,
                        isHvq_ML: true,
                        postalCode: hvqRes.policyAddress.postalCode ? hvqRes.policyAddress.postalCode.split('-')[0] : ""
                    });
                } else {
                    handleBridgingError(hvqTransactionId);
                }
            }, (error) => {
                handleBridgingError(hvqTransactionId, error);
            });
        }
        showCustomHeader(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return true;
}

export default withRouter(MLHVQLandingPage);
